<template>
  <div :class="['playerList',!isIamAdmin?'notAdmin':'']">
    <b-col v-if="isIamAdmin && !gameStarted" center class="startGameBox mt-1">
      <b-button
        v-if="onlinePlayerCount > 1"
        size="sm"
        class="mx-1"
        @click="startGame()"
        variant="primary"
        >{{ isFirstGame ? "Start Game" : "Play Again" }}</b-button
      >
      <b-button
        v-if="!isFirstGame && isIamAdmin && !gameStarted && onlinePlayerCount < 5"
        size="sm"
        class="mx-1"
        @click="reopenRoom()"
        variant="primary"
        >Reopen Room</b-button
      >
    </b-col>
    <b-container :class="['reltv', 'mt-2',(isIamAdmin && !gameStarted)?'pt-3':'pt-3']">
      <b-row
        :class="['playersListWrapper', playersCount == 1 ? 'onlyAdmin' : '']"
      >
        <b-col 
          :cols="playerId == myId && playersCount > 2 ? 12 : 0"
          class="px-1 col-md"
          v-for="playerId in orderedPlayerIds"
          :key="playerId"
        >
          <div
            :class="[
              'playerLabel',
              'reltv',
              'mb-1',
              myRoom[playerId].isOnline ? '' : 'offline',
              myRoom[playerId].winCount ? 'hasWinCount' : '',
              myRoomAdmin == playerId ? 'admin' : '',
              playerId == myId ? 'thisIsMe' : ''
            ]"
          >
            <unicon @click="kickoutPlayer(playerId)" v-if="isIamAdmin && (!gameStarted || BingoValue==5) && myRoom[playerId].isOnline" name="times" class="removePlayer" />
            <span class="robot" v-if="!myRoom[playerId].isOnline"><unicon name="robot" /></span>
            <div v-if="myRoomAdmin == playerId" class="adminLabel">Admin</div>
            <strong class="reltv" v-b-popover.hover.top="myRoom[playerId].playerName">
              <CrownSvg
                v-if="highestScorePlayerIds.indexOf(playerId) >= 0"
                fill="#fff"
                class="mr-1"
              />
              {{ myRoom[playerId].playerName }}
            </strong>
            <div v-if="myRoom[playerId].winCount" class="noOfWins">
              Wins: {{ myRoom[playerId].winCount }}
            </div>
            <PopedEmojis :playerId="playerId" />
            <ChatBubble v-if="playerId == myId && playersCount>1" />
            <ShowEmoji v-if="playerId == myId && playersCount>1" />
            <div
              class="timeOutBar"
              :style="{
                width:
                  (playerId == CurrentPlayerId && gameStarted
                    ? timeoutBarPercentage
                    : 0) + '%'
              }"
            ></div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import store from "@/store";
import Server from "@/server";
import CrownSvg from "@/components/svg/Crown";
import ShowEmoji from "@/components/ShowEmoji";
import PopedEmojis from "@/components/PopedEmojis";
import ChatBubble from "@/components/ChatBubble";
export default {
  methods: {
    startGame: () => {
      Server.startGame();
    },
    reopenRoom: () => {
      Server.reopenRoom();
    },
    kickoutPlayer:(playerId)=>{
      Server.kickoutPlayer(playerId);
    }
  },
  computed: {
    isIamAdmin: () => store.getters.isIamAdmin,
    onlinePlayerCount: () => store.getters.onlinePlayerCount,
    orderedPlayerIds: () => store.getters.orderedPlayerIds,
    highestScorePlayerIds: () => store.getters.highestScorePlayerIds,
    isFirstGame: () => store.getters.isFirstGame,
    gameStarted: () => store.state.room.gameStarted,
    playersCount: () => store.getters.playersCount,
    myRoom: () => store.state.room.myRoom,
    myRoomAdmin: () => store.state.room.myRoomAdmin,
    CurrentPlayerId: () => store.state.room.myRoomCurrentPlayer,
    myId: () => store.state.player.id,
    totalPlayers: () => store.getters.totalPlayers,
    currentPlayerIndex: () => store.getters.currentPlayerIndex,
    BingoValue: () => store.getters.BingoValue,
    timeoutBarPercentage: () => store.getters.timeoutBarPercentage,
    currentPlayerLabelLeftValue: function() {
      var { totalPlayers, currentPlayerIndex } = this;
      return (currentPlayerIndex / totalPlayers) * 100 - 100 / totalPlayers / 2;
    }
  },
  components: { CrownSvg, ShowEmoji, PopedEmojis, ChatBubble }
};
</script>
